import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

export async function excelFrontendDownload({ fields, data, fileName, worksheetName, formats = {} }) {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(worksheetName || "Sheet1");
    const headerRow = worksheet.addRow(fields);
    headerRow.eachCell((cell) => {
        cell.font = { bold: true };
        cell.alignment = { vertical: "middle", horizontal: "center" };
    });

    data.forEach((row) => {
        const dataRow = worksheet.addRow(row);
        dataRow.eachCell((cell, colNumber) => {
            const header = fields[colNumber - 1];
            if (formats[header]) cell.numFmt = formats[header];
            cell.alignment = { horizontal: "left" };
        });
    });

    worksheet.columns.forEach((col) => {
        let maxLength = 10;
        col.eachCell({ includeEmpty: true }, (cell) => {
            const cellValue = cell.value ? cell.value.toString() : "";
            maxLength = Math.max(maxLength, cellValue.length);
        });
        col.width = maxLength + 2;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
    saveAs(blob, fileName);
}